import React from 'react';
import { partners } from '../data/mock';
import { Camera, Diamond, Sparkles } from 'lucide-react';

const PartnerLogo = ({ name, type }) => {
  const renderLogo = () => {
    switch (type) {
      case 'amsterdam':
        return (
          <div className="flex items-center gap-2">
            <Camera className="w-5 h-5" />
            <span className="font-medium">Amsterdam</span>
          </div>
        );
      case 'savannah':
        return (
          <span className="font-bold tracking-wide">SAVANNAH</span>
        );
      case 'luminous':
        return (
          <div className="flex items-center gap-2">
            <Diamond className="w-5 h-5" />
            <span className="font-medium">luminous</span>
          </div>
        );
      case 'theo':
        return (
          <span className="font-light italic text-xl">Theo</span>
        );
      default:
        return <span>{name}</span>;
    }
  };

  return (
    <div className="flex items-center text-white/60 hover:text-white/80 transition-colors duration-300 px-8">
      {renderLogo()}
    </div>
  );
};

const PartnersMarquee = () => {
  // Double the partners array for seamless infinite scroll
  const doubledPartners = [...partners, ...partners];

  return (
    <section className="bg-[#0a0a0b] py-12 overflow-hidden border-y border-white/5">
      <div className="text-center mb-8">
        <p className="text-gray-400 text-sm">Helping tech businesses keep moving forward.</p>
      </div>
      
      <div className="relative">
        {/* Gradient masks for smooth edges */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0a0a0b] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0a0a0b] to-transparent z-10" />
        
        {/* Scrolling container */}
        <div className="flex animate-marquee">
          {doubledPartners.map((partner, index) => (
            <PartnerLogo key={`${partner.id}-${index}`} name={partner.name} type={partner.logo} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersMarquee;
